import { ADMINS_PATH } from '../utils/constants';
import { AdminsPage } from '../pages/Admins';
import { useAdminsPageOptions } from './useAdminsPageOptions';
import { useCurrentUser } from '../contexts/CurrentUserContext';
import { useMemo } from 'react';

export const useAdminRoutes = () => {
  const { currentUser } = useCurrentUser();
  const adminsPageOptions = useAdminsPageOptions();

  const routes = [];

  if (currentUser?.admin) {
    routes.push({
      path: ADMINS_PATH,
      Page: AdminsPage,
      exact: true,
    });
  }

  // Map over the options and return the path and page component.
  // Handle submenu items by extracting their children
  const options = [];

  adminsPageOptions.forEach((option) => {
    if (option.isSubmenu) {
      // Add all child routes from submenu
      option.children.forEach((child) => {
        options.push({
          path: child.route,
          Page: child.pageComponent,
          iframeSrc: child.iframeSrc,
          exact: child.exact,
        });
      });
    } else {
      // Add regular routes
      options.push({
        path: option.route,
        Page: option.pageComponent,
        iframeSrc: option.iframeSrc,
        exact: option.exact,
      });
    }
  });

  routes.push(...options);

  return useMemo(() => routes, [adminsPageOptions]);
};
